// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4040":"6ade515292e22ddb","8108":"2f7cb4a046f3962c","8809":"093606f06a14f484"}[chunkId] + ".js";
};